module.exports = __webpack_public_path__ + "img/veggiesSmall.559da52d.jpg";